import React from "react";
import { Box, InputAdornment, TextField, type TextFieldProps } from "@mui/material";
import { stripHash, withHash } from "./hexColor";

/**
 * Standalone color input with embedded color swatch on the left.
 * Use this for non-react-hook-form contexts (e.g. wizard state).
 * For react-hook-form, use ColorPicker instead.
 */
type ColorFieldProps = Omit<TextFieldProps, "onChange"> & {
  value: string;
  onChange: (value: string) => void;
};

const ColorField: React.FC<ColorFieldProps> = ({
  value,
  onChange,
  disabled,
  ...textFieldProps
}) => (
  <TextField
    {...textFieldProps}
    value={stripHash(value)}
    onChange={(e) => onChange(withHash(e.target.value))}
    placeholder="000000"
    disabled={disabled}
    slotProps={{
      input: {
        startAdornment: (
          <InputAdornment position="start">
            <Box
              component="input"
              type="color"
              value={value || "#000000"}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                onChange(e.target.value)
              }
              disabled={disabled}
              sx={{
                width: 28,
                height: 28,
                p: 0,
                border: "none",
                borderRadius: 1,
                cursor: disabled ? "default" : "pointer",
                bgcolor: "transparent",
                "&::-webkit-color-swatch-wrapper": { p: 0 },
                "&::-webkit-color-swatch": {
                  border: "none",
                  borderRadius: 3,
                },
                "&::-moz-color-swatch": {
                  border: "none",
                  borderRadius: 3,
                },
              }}
            />
            <Box component="span" sx={{ ml: 0.75, color: "text.secondary" }}>
              #
            </Box>
          </InputAdornment>
        ),
      },
    }}
  />
);

export default ColorField;
